import { Divider } from 'native-base';
import { JSX } from 'react';

export { Divider };

export const DividerSoft = (): JSX.Element => (
  <Divider backgroundColor="secondary.alpha.10:alpha.10" />
);
